import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import FurnishHome from "../pages/FurnishHome";
import SettingsPage from "../pages/SettingsPage";
import HistoryPage from "./HistoryPage";
import RemoveFurniture from "./RemoveFurniture";
import VariationsViewer from "./VariationsViewer";

const Dashboard: React.FC = () => {
  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-grow flex flex-col bg-gray-50">
        <Routes>
          {/* Redirect from "/" to "/furnish-home" */}
          <Route path="/" element={<Navigate to="/furnish-home" replace />} />
          <Route path="/furnish-home" element={<FurnishHome />} />
          <Route path="/remove-furniture" element={<RemoveFurniture />} />
          <Route path="/history" element={<HistoryPage />} />
          <Route
            path="/history/variations/:imageId"
            element={<VariationsViewer />}
          />
          <Route path="/settings" element={<SettingsPage />} />
          {/* Catch-all route to redirect any undefined paths to /furnish-home */}
          <Route path="*" element={<Navigate to="/furnish-home" replace />} />
        </Routes>
      </div>
    </div>
  );
};

const MainContent: React.FC<{ title: string }> = ({ title }) => {
  return (
    <>
      <div className="p-6">
        <h2 className="text-2xl font-bold mb-4">{title} Content</h2>
        <p>This is where the content for {title} will go.</p>
      </div>
    </>
  );
};

export default Dashboard;
